import React from 'react';
import { SearchValuesType, initialSearch } from '~/services';
import { searchFieldIsFiltered } from '~/util';

interface SearchSectionProps {
    defaultOpen: boolean;
    title: string;
    fields: (keyof SearchValuesType)[];
    values: Partial<SearchValuesType>;
    children?: React.ReactNode;
}
export function SearchSection({
    defaultOpen,
    title,
    fields,
    values,
    children,
}: SearchSectionProps) {
    const [open, setOpen] = React.useState(defaultOpen);

    const filterCount = fields.reduce((count, field) => {
        if (field === 'clinic' || field === 'PCP')
            return values[field] === null || (values[field] as []).length === 0 ? count : count + 1;
        return !searchFieldIsFiltered(field, initialSearch, values) ? count : count + 1;
    }, 0);

    return (
        <div className="row card mb-3">
            <button
                type="button"
                className="link-button header-button"
                onClick={() => setOpen((prev) => !prev)}
            >
                <div className="card-header">
                    <i className={`me-2 fa-solid fa-caret-${open ? 'down' : 'right'}`} />
                    {title}
                    {filterCount > 0 && (
                        <span className="float-end badge bg-primary">{filterCount}</span>
                    )}
                </div>
            </button>
            <div className={`card-body ${!open ? 'd-none' : ''}`}>{children}</div>
        </div>
    );
}
